import * as React from "react";
import { useMinimumWageQuery } from "../useMinimumWageQuery";
import { MinimalWageGeneralPageProps } from "../types";
import { useMinimumWageMutation } from "../useMinimumWageMutation";
import { useLocalize } from "@/modules/shared/context/localize/LocalizeContext";
import { MinimumWageCountryLayout } from "../components/MinimumWageCountryLayout";
import { GeneralMinimumWageConfigurationModel } from "@/app/models/configuration/minimumWage/generalMinimumWageConfigurationModel";
import { Loader } from "@/ui/feedback/Loader";
import { PreLoader } from "../components/PreLoader";
import { DateField } from "@/ui/form/controls/DateField";

export const GeneralMinimumWageSettingsPage = ({ match }: MinimalWageGeneralPageProps) => {
    const { companyId } = match.params
    const q = useMinimumWageQuery(companyId)
    const up = useMinimumWageMutation(companyId)
    const { t } = useLocalize()

    const [state, setState] = React.useState<GeneralMinimumWageConfigurationModel | null>(null)

    React.useEffect(() => {
        setState(null)
    }, [companyId])

    React.useEffect(() => {
        if (q.data) {
            const newState = structuredClone(q.data.generalConfiguration)
            setState(newState)
        }
    }, [q.data])

    const diffLabels = React.useMemo<Record<string, string>>(() => ({
        accommodationAndAllowanceMaxDate: t('configuration.timesheet.allowanceAndAccomodationMaxDate'),
    }), [t])

    if (!state || !q.data) {
        return <PreLoader />
    }
    {(q.isFetching || up.isPending) && (<Loader position="fixed" />)}

    const isDirty = JSON.stringify(state) !== JSON.stringify(q.data.generalConfiguration)

    return (
        <MinimumWageCountryLayout
            selectedCountryValue={''}
            isDirty={isDirty}
            handleSave={() => up.mutateAsync({ ...q.data, generalConfiguration: state })}
            handleCancel={() => setState(q.data.generalConfiguration)}
            dataTestId="general-minimum-wage-settings-page"
            isLoading={(q.isFetching || up.isPending)}
            diffBefore={q.data.generalConfiguration as Record<string, unknown>}
            diffAfter={state as Record<string, unknown>}
            diffLabels={diffLabels}
        >
            <div className="tw-px-2 tw-py-2">
                <DateField
                    label={t('configuration.timesheet.allowanceAndAccomodationMaxDate')}
                    value={state.accommodationAndAllowanceMaxDate ?? null}
                    clearable={false}
                    setValue={(v) =>
                        setState({ accommodationAndAllowanceMaxDate: v ?? '' })
                    }
                />
            </div>

            <div style={{ minHeight: '90px' }} />
        </MinimumWageCountryLayout>
    )
}
